import React, { useState } from 'react'
import { FieldTypes } from '../../utils/constants'
import Form from '../common/Form'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import ListHeader from '../common/ListHeader'
import useStyles from '../common/FormFields/FormFieldsStyle'

export default function BuildingForm({ onSubmit, handleCancel, building }) {
  const classes = useStyles()
  const history = useHistory()

  const [values, setValues] = useState(building || {})

  return (
    <div className={classes.paper}>
      <ListHeader
        bigTitle={`${building && building.id ? 'Editar' : 'Crear'} edificio`}
        canCreate={false}
      />
      <Form
        values={values}
        setValues={setValues}
        fields={[
          {
            type: FieldTypes.TextField,
            label: 'Nombre',
            hint: 'Ingrese un nombre',
            key: 'name',
            errorMessage: 'El nombre es requerido',
          },
          {
            type: FieldTypes.TextField,
            label: 'Url SIP',
            hint: 'Ingrese la url SIP',
            key: 'sipURL',
            errorMessage: 'La url SIP es requerida',
            withMargin: true,
          },
          {
            type: FieldTypes.TextField,
            label: 'Url WSS',
            hint: 'Ingrese la url WSS',
            key: 'wssURL',
            errorMessage: 'La url WSS es requerida',
            withMargin: true,
          },
          {
            type: FieldTypes.TextField,
            label: 'SIP SOS',
            hint: 'Ingrese el SIP SOS',
            errorMessage: 'El SIP SOS es requerida',
            key: 'sipSOS',
            withMargin: true,
          },
          {
            type: FieldTypes.TextField,
            label: 'Url Portero',
            hint: 'Ingrese la url del portero',
            errorMessage: 'La url del portero es requerida',
            key: 'doorbellURL',
            withMargin: true,
          },
          {
            type: FieldTypes.Select,
            id: 'type',
            label: 'Tipo',
            hint: 'Seleccione un tipo',
            key: 'type',
            errorMessage: 'El tipo es requerido',
            options: [
              { value: 'neighborhood', label: 'Barrio' },
              { value: 'building', label: 'Edificio' },
            ],
          },
          {
            type: FieldTypes.Switch,
            label: 'Foto de usuario requerida',
            key: 'requiredImage',
          },
        ]}
        handleSubmit={() => {
          onSubmit(values)
          history.push('/edificios')
        }}
        handleCancel={handleCancel}
      />
    </div>
  )
}
